module.exports = __webpack_public_path__ + "8e6368fe26ad9fac35672fa2d27a5c74.MP3";